import React, { ReactElement } from "react";
import dynamic from "next/dynamic";

const Footer = dynamic(() => import("@components/shared/footer"));
export default function MainLayout({ children }): ReactElement {
    return (
        <div>
            {children}
            <Footer />
        </div>
    );
}
